export default {"src":"/_next/static/media/juggling-robot.aa9b670d.svg","height":99,"width":94};